import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.number.constructor";
// import Campaign from './Campaign.vue'
// import addReference from './ReferenceAdd'
// import VueTinySlider from 'vue-tiny-slider'
import staticText from '@/assets/static.json';
import onlineBranchApi from '@/api/finance/onlinebranch';
import adminApi from '@/api/dms/admin';
export default {
  name: 'AsideOfMain',
  components: {
    // 'campaign': Campaign,
    // 'add-reference': addReference,
    // 'tiny-slider': VueTinySlider
  },
  data: function data() {
    return {
      lastNonPayed2: null,
      hide: true,
      titleBusy: false,
      text: staticText,
      percentage: 100,
      showBusy: false,
      activeName: '0',
      groupList: [],
      productList: [],
      showOk: false,
      action: 'create',
      dialogVisiable: false,
      isShowFull: false,
      show: true,
      customerId: null,
      dialogVisible: false,
      model: {
        party: this.$store.state.user.customerId,
        firstName: null,
        middleName: null,
        lastName: null,
        telNo: null,
        isReference: true,
        iBranch: true,
        iBranchCustomerId: 0
      },
      productList2: [],
      counter: null,
      intArrDelivery: [],
      intArrProduct: [],
      imageLoaded: false,
      iSubeSlidingWindowUrl: ''
    };
  },
  created: function created() {
    // this.getProductList()
    // this.lastUnpaidDebt()
    this.productListOfOnline();
    this.lastUnpaidDebt();
    this.deliveryCounter();
    this.iSubeSlidingWindow();
  },
  methods: {
    clicks: function clicks(item) {
      if (item.referralLink === 'null') {
        return;
      }
      window.open('https://' + item.referralLink, '_blank');
    },
    getImagePath: function getImagePath(item) {
      return process.env.VUE_APP_BASE_API + 'api/d/v1/viewer?year=' + item.imagePath;
    },
    iSubeSlidingWindow: function iSubeSlidingWindow() {
      var _this = this;
      adminApi.getImages(3).then(function (v) {
        if (v.data != null) {
          _this.iSubeSlidingWindowUrl = v.data;
          _this.imageLoaded = true;
        }
      }).catch(function () {
        _this.$notify.error(_this.$t('notify.error'));
      });
      this.dialogImage = false;
    },
    deliveryCounter: function deliveryCounter() {
      var _this2 = this;
      this.busy = true;
      onlineBranchApi.deliveryCounter().then(function (v) {
        _this2.counter = v.data;
        var myFunc = function myFunc(num) {
          return Number(num);
        };
        _this2.intArrDelivery = Array.from(String(_this2.counter.deliveryCount), myFunc);
        _this2.intArrProduct = Array.from(String(_this2.counter.productCount), myFunc);
      }).catch(function () {}).finally(function () {
        _this2.busy = false;
      });
    },
    productListOfOnline: function productListOfOnline() {
      var _this3 = this;
      this.busy = true;
      onlineBranchApi.productListInternetBranch().then(function (v) {
        _this3.productList2 = v.data.list;
      }).catch(function () {}).finally(function () {
        _this3.busy = false;
      });
    },
    // groupIcon(item) {
    //   if (item.financeType.name === 'house') {
    //     return 'mini-home'
    //   } else if (item.financeType.name === 'car') {
    //     return 'mini-car'
    //   } else {
    //     return 'mini-saving'
    //   }
    // },
    // deliveryIcon(item) {
    //   if (item.financeType.name === 'house') {
    //     return 'mini-home'
    //   } else if (item.financeType.name === 'car') {
    //     return 'mini-car'
    //   } else {
    //     return 'mini-saving'
    //   }
    // },
    showFull: function showFull() {
      this.isShowFull = !this.isShowFull;
    },
    references: function references() {
      this.$router.push({
        name: 'references',
        path: '/references'
      });
    },
    mapRoute: function mapRoute() {
      this.$router.push({
        name: 'map',
        path: '/map'
      });
    },
    handleClick: function handleClick(val, event) {
      this.orderedProductByCalculation(this.productList[val.index].calculationId);
    },
    // getName(item) {
    //   return item.financeType.name
    // },
    returnedValue: function returnedValue() {
      this.dialogVisible = false;
      this.showOk = true;
    },
    lastUnpaidDebt: function lastUnpaidDebt() {
      var _this4 = this;
      this.titleBusy = true;
      this.busy = true;
      onlineBranchApi.lastUnpaidDebts().then(function (v) {
        if (v.data !== '' && v.data !== null) {
          _this4.lastNonPayed2 = v.data;
          _this4.lastNonPayed2.code = v.data.product.code;
          _this4.lastNonPayed2.productId = v.data.product.productId;
          _this4.lastNonPayed2.paymentDate = v.data.paymentPlan.paymentDate;
          _this4.lastNonPayed2.remainAmount = v.data.paymentPlan.remainAmount;
          _this4.productList2.forEach(function (i) {
            if (i.code === _this4.lastNonPayed2.code) {
              _this4.lastNonPayed2.calculationId = i.calculationId;
            }
          });
          _this4.titleBusy = false;
        } else {
          _this4.lastNonPayed2 = null;
          _this4.titleBusy = false;
        }
      });
    },
    goToDetail: function goToDetail() {
      this.dialogVisible2 = false;
      this.$router.push({
        name: 'payment-information',
        path: '/payment-information'
      });
    }
  }
};